import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface FAQItemProps {
  q: string;
  a: string;
}
function FAQItem({
  q,
  a
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl border border-[#EAEAEA] overflow-hidden" data-id="element-114">
      <div className="p-4 sm:px-5 sm:py-4 text-[14px] font-bold text-oscuro cursor-pointer flex justify-between items-center gap-3 select-none hover:bg-crema transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-115">
        {q}
        <motion.div animate={{
        rotate: isOpen ? 90 : 0
      }} transition={{
        duration: 0.2
      }} className="text-rosa flex-shrink-0" data-id="element-116">
          <ChevronRight size={18} data-id="element-117" />
        </motion.div>
      </div>
      <AnimatePresence data-id="element-118">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-119">
            <div className="px-4 sm:px-5 pb-4 text-[13px] text-gris leading-[1.65] border-t border-[#F0F0F0] pt-3.5" data-id="element-120">
              {a}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. El acceso es permanente y podés descargar los archivos todas las veces que necesites desde cualquier dispositivo.'
  }, {
    q: '¿Sirve si recién empiezo o solo si ya tengo clientas?',
    a: 'Sirve para las dos situaciones. Si estás empezando, el kit te da la base profesional desde el primer día. Si ya tenés clientas, te da el sistema para organizarlas mejor y hacer crecer tus ingresos sin conseguir nuevas.'
  }, {
    q: '¿Necesito saber diseño o usar programas complejos?',
    a: 'No. Las plantillas están diseñadas para editarse en Canva o Word — dos herramientas gratuitas y muy fáciles de usar. Solo reemplazás tu nombre, logo y precios. En 10 minutos tenés el primer documento listo para enviar.'
  }, {
    q: '¿Los 3 bonos están incluidos en las dos ofertas?',
    a: 'Sí. Los tres bonos (Guía de WhatsApp Business, Planilla Mensual y Guión de Cierre de Presupuesto) están incluidos sin costo adicional en la Oferta Esencial y en la Oferta Completa.'
  }, {
    q: '¿Funciona si trabajo sola desde mi casa?',
    a: 'Está hecho exactamente para eso. La esteticista que trabaja sola o en pequeño centro es quien más necesita este sistema porque no tiene equipo de marketing ni diseñadora. El kit resuelve todo desde el celular, sin depender de nadie más.'
  }, {
    q: '¿Qué diferencia tiene con plantillas gratuitas de Canva?',
    a: 'Las plantillas de Canva son genéricas y no tienen contexto de uso. El kit incluye no solo el diseño sino el texto exacto de cada documento, los guiones para cada situación, la estrategia de cuándo y cómo usarlos, y la conexión entre todos los elementos para que funcionen como un sistema. No es diseño — es el sistema completo de tu negocio.'
  }, {
    q: '¿Por qué elegir la Oferta Completa y no la Esencial?',
    a: 'La Esencial te da todo para profesionalizar tu comunicación y tu imagen desde hoy. La Completa agrega el sistema para multiplicar tus ingresos con las clientas que ya tenés — a través del método de fidelización (Tomo 7) y el método de aumento de precios (Tomo 8). La diferencia de $8.000 se recupera con un solo aumento de precio bien comunicado.'
  }, {
    q: '¿La garantía es real?',
    a: 'Completamente real. Tenés 7 días para revisar el kit, probarlo en tu trabajo real y decidir si es lo que necesitabas. Si no quedás satisfecha, te devolvemos el 100% sin ninguna pregunta. Nuestra tasa de devoluciones es menor al 1% porque el sistema funciona — pero la garantía existe porque queremos que la decisión sea sin riesgo para vos.'
  }];
  return <section className="bg-crema py-10 sm:py-16 px-5" data-id="element-121">
      <div className="max-w-[720px] mx-auto" data-id="element-122">
        <div className="text-center mb-8 sm:mb-12" data-id="element-123">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] text-oscuro uppercase" data-id="element-124">
            PREGUNTAS FRECUENTES
          </h2>
        </div>
        <div className="flex flex-col gap-2" data-id="element-125">
          {faqs.map((faq, idx) => <FAQItem key={idx} q={faq.q} a={faq.a} data-id="element-126" />)}
        </div>
      </div>
    </section>;
}